/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../../node_modules/@swimlane/ngx-datatable/release/components/datatable.component.ngfactory';
import * as i3 from '@swimlane/ngx-datatable/release/components/datatable.component';
import * as i4 from '@swimlane/ngx-datatable/release/services/scrollbar-helper.service';
import * as i5 from '@swimlane/ngx-datatable/release/services/dimensions-helper.service';
import * as i6 from '../../../../../app/components/currencyExchange/currencyTable/currencyTable.component';
const styles_CurrencyTableComponent:any[] = ([] as any[]);
export const RenderType_CurrencyTableComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_CurrencyTableComponent,data:{}});
function View_CurrencyTableComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),[' ',' ']))],(null as any),(_ck,
      _v) => {
    const currVal_0:any = _v.context.column.name;
    _ck(_v,0,0,currVal_0);
  });
}
function View_CurrencyTableComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),[' ',' ']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.convertName(_v.context.row.Name);
    _ck(_v,0,0,currVal_0);
  });
}
function View_CurrencyTableComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),[' ',' '])),i0.ɵppd(2)],(null as any),
      (_ck,_v) => {
        const currVal_0:any = i0.ɵunv(_v,0,0,_ck(_v,1,0,i0.ɵnov((<any>_v.parent),0),
            _v.context.column.name,'yMd'));
        _ck(_v,0,0,currVal_0);
      });
}
function View_CurrencyTableComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),[' ',' ']))],(null as any),(_ck,
      _v) => {
    const currVal_0:any = _v.context.row.Items[_v.context.column.index].Value;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_CurrencyTableComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵpid(0,i1.DatePipe,[i0.LOCALE_ID]),i0.ɵqud(402653184,1,{editTmpl:0}),
      i0.ɵqud(402653184,2,{hdrTpl:0}),i0.ɵqud(402653184,3,{editTmp2:0}),i0.ɵqud(402653184,
          4,{hdrTp2:0}),(_l()(),i0.ɵeld(0,(null as any),(null as any),6,'ngx-datatable',
          [['class','material striped table-bordered ngx-datatable']],[[2,'fixed-header',
              (null as any)],[2,'fixed-row',(null as any)],[2,'scroll-vertical',(null as any)],
              [2,'scroll-horz',(null as any)],[2,'selectable',(null as any)],[2,'checkbox-selection',
                  (null as any)],[2,'cell-selection',(null as any)],[2,'single-selection',
                  (null as any)],[2,'multi-selection',(null as any)],[2,'multi-click-selection',
                  (null as any)]],[['window','resize']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('window:resize' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,6).onWindowResize()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_DatatableComponent_0,i2.RenderType_DatatableComponent)),i0.ɵdid(5619712,
          (null as any),4,i3.DatatableComponent,[[1,i4.ScrollbarHelper],[1,i5.DimensionsHelper],
              i0.ChangeDetectorRef,i0.ElementRef,i0.KeyValueDiffers],{rows:[0,'rows'],
              columns:[1,'columns'],rowHeight:[2,'rowHeight'],columnMode:[3,'columnMode']},
          (null as any)),i0.ɵqud(603979776,5,{columnTemplates:1}),i0.ɵqud(335544320,
          6,{rowDetail:0}),i0.ɵqud(335544320,7,{groupHeader:0}),i0.ɵqud(335544320,
          8,{footer:0}),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵand(0,[[2,2],['hdrTpl',2]],(null as any),0,(null as any),
          View_CurrencyTableComponent_1)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵand(0,[[1,2],['editTmpl',2]],(null as any),0,(null as any),View_CurrencyTableComponent_2)),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(0,[[4,2],['hdrTp2',2]],
          (null as any),0,(null as any),View_CurrencyTableComponent_3)),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵand(0,[[3,2],['editTmp2',2]],(null as any),0,(null as any),
          View_CurrencyTableComponent_4)),(_l()(),i0.ɵted((null as any),[' ']))],(_ck,
      _v) => {
    var _co:i6.CurrencyTableComponent = _v.component;
    const currVal_10:any = _co.tableItems;
    const currVal_11:any = _co.columns;
    const currVal_12:any = 'auto';
    const currVal_13:any = 'force';
    _ck(_v,6,0,currVal_10,currVal_11,currVal_12,currVal_13);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,6).isFixedHeader;
    const currVal_1:any = i0.ɵnov(_v,6).isFixedRow;
    const currVal_2:any = i0.ɵnov(_v,6).isVertScroll;
    const currVal_3:any = i0.ɵnov(_v,6).isHorScroll;
    const currVal_4:any = i0.ɵnov(_v,6).isSelectable;
    const currVal_5:any = i0.ɵnov(_v,6).isCheckboxSelection;
    const currVal_6:any = i0.ɵnov(_v,6).isCellSelection;
    const currVal_7:any = i0.ɵnov(_v,6).isSingleSelection;
    const currVal_8:any = i0.ɵnov(_v,6).isMultiSelection;
    const currVal_9:any = i0.ɵnov(_v,6).isMultiClickSelection;
    _ck(_v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9);
  });
}
export function View_CurrencyTableComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'currency-table',
      ([] as any[]),(null as any),(null as any),(null as any),View_CurrencyTableComponent_0,
      RenderType_CurrencyTableComponent)),i0.ɵdid(114688,(null as any),0,i6.CurrencyTableComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CurrencyTableComponentNgFactory:i0.ComponentFactory<i6.CurrencyTableComponent> = i0.ɵccf('currency-table',
    i6.CurrencyTableComponent,View_CurrencyTableComponent_Host_0,{currencyItems:'currencyItems'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/app/components/currencyExchange/currencyTable/currencyTable.component.ngfactory.ts